export default class WordingSearch {
	constructor() {
		this.$container = $(".j-search-wording-container");
		this.$elements = this.$container.find(
			".tab-pane .form-group.string, .tab-pane .form-group.select, .tab-pane .form-group.text",
		);
		this.$resetSearchButton = this.$container.find(".j-fuzzy-search-reset");
		this.$wordingDropdown = this.$container.find(".j-custom-wording-dropdown");

		this.$resetSearchButton.on("click", this.resetSearch.bind(this));
		$(".j-fuzzy-search-input").on(
			"keyup",
			this.debounce(this.search.bind(this), 300),
		);
	}

	search(e) {
		const searchInput = $(e.target).val();
		this.$resetSearchButton.removeClass("hidden");
		this.$wordingDropdown.addClass("hidden");
		if (searchInput === "") {
			this.resetSearch();
			return;
		}
		this.$container.find(".tab-pane").addClass("in active");
		const $matchingElements = this.searchElements(searchInput);
		pp.log("search", searchInput, $matchingElements);
		$matchingElements.removeClass("hidden");
	}

	resetSearch() {
		$(".j-fuzzy-search-input").val("");
		this.$resetSearchButton.addClass("hidden");
		this.$wordingDropdown.removeClass("hidden");
		this.$elements.removeClass("hidden");
		this.$container.find(".tab-pane").removeClass("in active");
		this.$wordingDropdown.find(".dropdown-menu li a").first().click();
	}

	searchElements(searchInput) {
		this.$elements.addClass("hidden");

		const $matchingElements = this.$elements.filter((idx, el) => {
			const elementValues = this.getElementValues($(el));

			return (
				(elementValues.placeholderText &&
					this.fuzzyMatch(elementValues.placeholderText, searchInput)) ||
				(elementValues.labelText &&
					this.fuzzyMatch(elementValues.labelText, searchInput)) ||
				(elementValues.inputValue &&
					this.fuzzyMatch(elementValues.inputValue, searchInput)) ||
				(elementValues.selectValue &&
					this.fuzzyMatch(elementValues.selectValue, searchInput))
			);
		});

		return $matchingElements;
	}

	getElementValues($element) {
		const placeholderText = $element
			.find("input, textarea")
			.attr("placeholder");
		const labelText = $element.find("label").text();
		const inputValue = $element.find("input, textarea").val();
		const selectValue = $element.find("select option").text();

		return {
			placeholderText,
			labelText,
			inputValue,
			selectValue,
		};
	}

	fuzzyMatch(input, search) {
		if (!input || !search) return false;

		input = input.toLowerCase();
		search = search.toLowerCase();

		return input.includes(search);
	}

	debounce(func, wait) {
		let timeout;

		return function () {
			// Needs to be called `function` because otherwise `this` would not exist in the function body
			// @ts-expect-error
			const context = this;
			const args = arguments;

			const later = function () {
				timeout = null;
				func.apply(context, args);
			};

			clearTimeout(timeout);
			timeout = setTimeout(later, wait);
		};
	}
}
